'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAddSetButton = exports.StyledSetHeaderRow = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  justify-content: space-between;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: ', ';\n  cursor: pointer;\n  background: ', ';\n  border: 1px solid ', ';\n  opacity: 0.7;\n  transition: opacity 175ms linear;\n\n  &:hover {\n    opacity: 1;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: ', ';\n  cursor: pointer;\n  background: ', ';\n  border: 1px solid ', ';\n  opacity: 0.7;\n  transition: opacity 175ms linear;\n\n  &:hover {\n    opacity: 1;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('calcite-react/utils/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledSetHeaderRow = _styledComponents2.default.div(_templateObject);

var StyledAddSetButton = _styledComponents2.default.div(_templateObject2, function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 3, '/');
}, function (props) {
  return props.theme.palette.lightestGray;
}, function (props) {
  return props.theme.palette.lighterGray;
});

exports.StyledSetHeaderRow = StyledSetHeaderRow;
exports.StyledAddSetButton = StyledAddSetButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/arcgis-filter/dist/containers/Set-styled.js
// module id = 683
// module chunks = 0